import { ErrorScreen } from "./ErrorScreen";
import React from "react";

export const Error500Screen = () => <ErrorScreen description="That's all we know" heading="Something went wrong" />;
